import { Reducer } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import { RESET } from 'action-creators/generic';
import {
  HOTEL_LOCATIONS_REQUEST,
  HOTEL_LOCATIONS_SUCCESSFUL,
  HOTEL_LOCATIONS_FAILURE,
} from 'action-creators/hotelLocations';
import { TravelHotelSearchResponse } from 'models/hotelLocation';

export interface HotelLocationsState {
  isLoading: boolean;
  bySearch: TravelHotelSearchResponse | undefined;
  error: string | null;
}

const initialState: HotelLocationsState = {
  isLoading: false,
  bySearch: undefined,
  error: null,
};

const reducer: Reducer<HotelLocationsState> = (state = initialState, action) => {
  switch (action.type) {
    case HOTEL_LOCATIONS_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case HOTEL_LOCATIONS_SUCCESSFUL:
      return {
        ...state,
        bySearch: action.payload,
        isLoading: false,
      };
    case HOTEL_LOCATIONS_FAILURE:
      return {
        ...state,
        error: action.payload,
        bySearch: undefined,
        isLoading: false,
      };
    case RESET:
      return initialState;
    default:
      return state;
  }
};

const persistConfig = {
  storage,
  version: 1,
  key: 'hotelLocations',
  blacklist: ['isLoading', 'error'],
};

export default persistReducer(persistConfig, reducer);
